import {
  formatPercentageValue,
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { uniquePageViews, uniquePageViewsDelta } =
      data.getUserAdoptionScorecard;
    return createKpiTileItem(
      'Unique Page Views',
      formatNormalNumber(uniquePageViews),
      uniquePageViewsDelta
        ? {
            isPositiveValue: uniquePageViewsDelta >= 0,
            text: formatPercentageValue(Math.abs(uniquePageViewsDelta)),
            sideLabel: '',
            showArrow: Number(uniquePageViewsDelta) !== 0,
          }
        : null
    );
  },
};
